import { useQuery } from "react-query";
import { apiGetServices } from "../../../../../api/service/apiGetServices";
import { SERVICE_STATE } from "../../../../../api/service/service.types";
import { TServicesPageFilters } from "./useServicesPageFilters";

export default function useServicesPageQuery(
  servicesPageFilters: TServicesPageFilters
) {
  return useQuery(
    ["services", servicesPageFilters],
    async () => {
      const params = {
        itemsPerPage: 10,
        partial: 1,
        page: servicesPageFilters.page,
      } as any;

      if (servicesPageFilters.search !== "") {
        params.orSearch_searchFor = servicesPageFilters.search;
      }
      if (servicesPageFilters.businessCountry !== "") {
        params.businessCountry = servicesPageFilters.businessCountry;
      }
      // if (servicesPageFilters.state.length) {
      //   params.state = servicesPageFilters.state;
      // }
      if (servicesPageFilters.preset === "new") {
        params.state = [
          SERVICE_STATE.AWAITING,
          SERVICE_STATE.WITHOUT_VALIDATION,
        ];
      }
      if (servicesPageFilters.preset === "valuated") {
        params.state = [SERVICE_STATE.VALUED, SERVICE_STATE.CLOSED];
      }
      if (servicesPageFilters.preset === "follow-up") {
        params.state = [SERVICE_STATE.CLOSED];
        params["lastFollowUpAt[before]"] = servicesPageFilters.days15Ago;
        params["contractedAt[before]"] = servicesPageFilters.days15Ago;
      }
      if (!params.owner && servicesPageFilters.owner.length) {
        params.owner = servicesPageFilters.owner;
      }
      if (params.owner === "owner") {
        delete params.owner;
      }
      if (servicesPageFilters.cOwner.length) {
        params["deal.owner"] = servicesPageFilters.cOwner;
      }
      params["order[createdAt]"] = "desc";

      // let res = await apiEmpleo.get("services", { params });
      const res = await apiGetServices(params);
      const services = res["hydra:member"];
      return {
        services,
        totalItems: res["hydra:totalItems"],
      };
    },
    {
      enabled: servicesPageFilters.ready,
      cacheTime: 1000 * 60 * 5,
    }
  );
}
